export const isDebugMode: boolean = process.env.REACT_APP_DEBUG === "true";
export const isDebugPerformanceMode: boolean = process.env.REACT_APP_DEBUG_PERFORMANCE === "true";